import ConfigService from '../index'
class FinalidadeService extends ConfigService {
    constructor(){
        super('agendalabs/api/v1/finalidades/')
    }
}
export default FinalidadeService
